import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';

const AddEditAdminModule = ({ editable, viewable, onHide, rowRecord, onClose }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [allPermissions, setAllPermissions] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),
        modulePath: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        moduleIcon: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            id: '',
            modulePath: '',
            moduleIcon: '',
            name: '',
            createdBy: '',
            modifiedBy: ''
        },

        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

            setLoadingBtn(true);
            const addData = {
                modulePath: data.modulePath,
                moduleIcon: data.moduleIcon,
                name: data.name,
                createdBy: user?.data?.userId,
                permissionIds: allPermissions.map((perm) => perm.id)
            };

            const editData = {
                id: data.id,
                modulePath: data.modulePath,
                moduleIcon: data.moduleIcon,
                permissionIds: selectedPermissions,
                name: data.name,
                modifiedBy: user?.data?.userId
            };

            if (!editable) {
                const response = await dispatch(handlePostRequest(addData, endPoints.createAdminModule, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                const response = await dispatch(handlePutRequest(editData, endPoints.updateAdminModule, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getAdminModuleById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getAdminModuleById(rowRecord.id), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('modulePath', response?.data?.modulePath);
            formik.setFieldValue('moduleIcon', response?.data?.moduleIcon);
            formik.setFieldValue('name', response?.data?.name);
            const mappedPermissions = response?.data?.permissions.map((item) => item?.permissionId);
            setSelectedPermissions(mappedPermissions);
        }
        setLoadingBtn(false);
    };

    const getModulePermission = async () => {
        const response = await handleGetRequest(endPoints.getDropdownPermissions, true, false, dispatch);
        if (response) {
            setAllPermissions(response?.data);
        }
    };

    useEffect(() => {
        getModulePermission();
    }, []);

    useEffect(() => {
        if (editable || viewable) {
            getAdminModuleById();
        }
    }, [rowRecord]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="name">
                            Module Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="name" name="name" placeholder="Enter Module Name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="modulePath">
                            Module Path <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="modulePath" name="modulePath" placeholder="Enter Module Path" value={formik?.values?.modulePath} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.modulePath && formik.errors.modulePath && <small className="p-error">{formik.errors.modulePath}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="moduleIcon">
                            Icon <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="moduleIcon" name="moduleIcon" placeholder="Enter Module Icon" value={formik?.values?.moduleIcon} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.moduleIcon && formik.errors.moduleIcon && <small className="p-error">{formik.errors.moduleIcon}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default AddEditAdminModule;
